'use strict';

// eslint-disable-next-line max-lines-per-function
angular.module('webAgro1App').factory('ItensService', function($http) {
  return {
    listItemsBalance: function(filters) {
      const url = `${SERVER + API_VERSION}itens/saldo`;
      return $http.get(url, { params: filters });
    },

    // eslint-disable-next-line complexity
    listCultivares: function(filters) {
      filters = {
        no_paginate: (filters || {}).no_paginate !== false,
        only_cultivares: (filters || {}).item ? null : true,
        atividade: (filters || {}).atividade,
        tipo_item: (filters || {}).tipo_item,
        possui_tratamento: (filters || {}).possui_tratamento,
        item: (filters || {}).item
      };
      return $http.get(`${SERVER + API_VERSION}itens`, { params: filters });
    },

    listAdubos: function() {
      const filters = { no_paginate: true };
      return $http.get(`${SERVER + API_VERSION}adubos`, { params: filters });
    },

    // eslint-disable-next-line max-lines-per-function, complexity, max-len
    stockIsNegative: function(produto, hasDepositInUse) {
      const controlaLote = produto.controla_lote || produto.controlaLote;

      let saldo;
      if (controlaLote) {
        const { emUso = 0, fisico = 0 } = produto.lote || {};
        saldo = (hasDepositInUse ? emUso : fisico);
      } else {
        /* eslint-disable camelcase */
        const { saldo_em_uso = 0, saldo_fisico = 0 } = produto;
        saldo = (hasDepositInUse ? saldo_em_uso : saldo_fisico);
        /* eslint-disable camelcase */
      }

      const quantidadeTotal = parseFloat(produto.quantidadeTotal || produto.qt_total);

      saldo = (saldo || 0);

      if (produto.unidadeOriginal && produto.unidade) {
        // eslint-disable-next-line max-len
        return (saldo - parseFloat(quantidadeTotal * produto.unidadeOriginal.conversao / produto.unidade.conversao)) < 0;
      }

      return (saldo - quantidadeTotal < 0);
    }
  };
});
